module.exports = __webpack_public_path__ + "images/2e642a6e5b47446e36bacd1aba101fd2f.svg";